(() => {
  const dialog = document.getElementById('GMInquiry');
  if (!dialog) return;
  let opener;
  const work = dialog.querySelector('#GMInquiryWork');
  const record = dialog.querySelector('#GMInquiryRecord');
  const form = dialog.querySelector('#GMInquiryForm');
  const fields = form.querySelector('[data-gm-fields]');
  const success = form.querySelector('[data-gm-success]');
  const error = form.querySelector('[data-gm-error]');
  const submit = form.querySelector('[type=submit]');
  const sendLabel = submit.textContent;
  const title = dialog.querySelector('#GMInquiryTitle');
  const inquiryTitle = title.textContent;
  const intro = dialog.querySelector('[data-gm-intro]');
  let pending = false;
  const close = () => { dialog.close(); if (opener?.isConnected) opener.focus(); };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-inquire-piece]');
    if (!button) return;
    if (pending) return;
    opener = button;
    fields.hidden = false;
    success.hidden = true;
    error.hidden = true;
    title.textContent = button.textContent.trim() || inquiryTitle;
    intro.hidden = false;
    dialog.classList.remove('gm-inquiry--sent');
    if (work) work.value = button.dataset.inquirePiece || '';
    if (record) record.value = button.dataset.inquireUrl || '';
    dialog.showModal();
  });
  dialog.querySelector('[data-gm-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  dialog.addEventListener('click', (event) => { if (event.target === dialog) {
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
  }});
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || !form.reportValidity() || form.elements.website.value) return;
    pending = true;
    submit.disabled = true;
    submit.textContent = submit.dataset.sendingLabel;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    const data = new FormData(form);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);
    try {
      const response = await fetch(form.action, {
        method: 'POST', body: data,
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Submission failed');
      const result = await response.json();
      if (result.success === false || result.error || result.errors) throw new Error('Submission failed');
      fields.hidden = true;
      success.hidden = false;
      title.textContent = title.dataset.successTitle;
      intro.hidden = true;
      dialog.classList.add('gm-inquiry--sent');
      form.reset();
    } catch {
      error.hidden = false;
    } finally {
      clearTimeout(timeout);
      pending = false;
      submit.disabled = false;
      submit.textContent = sendLabel;
      form.removeAttribute('aria-busy');
    }
  });
})();
